// frontend/src/services/personService.js

const API = process.env.REACT_APP_API_BASE || '';

/**
 * Obtener persona por persons.id
 * Endpoint: GET /api/person/id/:id
 */
export async function getPersonById(id, accessHash, jwt) {
  if (!id) throw new Error('Missing person id');

  const res = await fetch(`${API}/api/person/id/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...(accessHash ? { 'x-access-hash': accessHash } : {}),
      ...(jwt ? { Authorization: `Bearer ${jwt}` } : {}),
    },
    credentials: 'include',
  });

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    console.error('Error en getPersonById. Respuesta del servidor:', text);
    throw new Error(text || 'Person not found');
  }
  return res.json();
}

/**
 * Obtener persona por cédula.
 * Endpoint: GET /api/person/:nationalId
 * Acepta opcionalmente x-access-hash y Authorization como en el resto de métodos.
 */
export async function getPersonByNationalId(nationalId, accessHash, jwt) {
  const res = await fetch(`${API}/api/person/${encodeURIComponent(nationalId)}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...(accessHash ? { 'x-access-hash': accessHash } : {}),
      ...(jwt ? { Authorization: `Bearer ${jwt}` } : {}),
    },
    credentials: 'include',
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || 'Person not found');
  }
  return res.json();
}


/**
 * Actualizar datos de persona (tabla persons)
 * Endpoint: PUT /api/person/id/:personId
 */
export async function updatePerson(personId, payload, accessHash, jwt) {
  if (!personId) throw new Error('Missing person id');

  const res = await fetch(`${API}/api/person/id/${personId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...(accessHash ? { 'x-access-hash': accessHash } : {}),
      ...(jwt ? { Authorization: `Bearer ${jwt}` } : {}),
    },
    credentials: 'include',
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    let detail;
    try { detail = JSON.parse(text); } catch { detail = { message: text }; }
    const err = new Error(detail?.message || `updatePerson failed: ${res.status}`);
    err.status = res.status;
    err.detail = detail;
    throw err;
  }
  return res.json();
}
